export function ReloadPrompt() {
  return null;
}

export default ReloadPrompt;
